// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"FooterTC_TheComp__2IlBr"};